/**
 * Created by Zac on 7/03/2016.
 */
 import { SASubjectiveFeedbackHandler } from './activities/short-answer';


 $(document).ready(() => {
//    let clock;
   let clockStopReason;
   let parentDiv;

   let numIncorrect = 0;

   function showFeedback() {
       console.log('Showing feedback summary');
       const feedbackDivs = parentDiv.find('.isActivity .alert-error[style="display: block;"]');
       const combinedFeedback = $('<ul class="feedback-summary"></ul>');

       $.each(feedbackDivs, function () {
           const feedbackText = (parentDiv.hasClass('autofeedback')) ? (`The correct answer is ${$(this).parent().find('.alert-success').data('values')}`) : $(this).text();
           console.log(feedbackText);

           const item = $(`${'<li>' +
                '<div class="Question">'}${$(this).parent().find('.Question').html()}</div>` +
                `<div class="submitted-response"><p>You submitted: ${$(this).parent().find('.Response input').val()}</p></div>` +
                `<div class="Feedback alert-error">${feedbackText}</div></li>`);
           combinedFeedback.append(item);
         });
       parentDiv.append(combinedFeedback);
     }

   $('.click-sequence .sequence-activity-wrapper').hide();       // Hide all the activities by default

   if ($('.click-sequence').hasClass('timed')) {
       $('.restart').click(() => {
           if (DEBUGGING) console.log('restarting');
           parentDiv.find('.start-timer').click();
         });

       $('.click-sequence .start-timer').click(function () {
           if (DEBUGGING) console.log('Starting');
           clockStopReason = '';
           numIncorrect = 0;
           $('.FeedbackRange').hide();
           $('.Feedback').hide();
           $('.click-sequence .feedback-button').hide();
           $('.click-sequence .sequence-activity-wrapper').hide();       // Hide all the activities by default
           $('.feedback-summary').remove();
           $('.click-sequence input').val('');


           Cookies.set('finalscore', 0, { expires: 7, path: '/' });         // Reset the cookie score

           parentDiv = $(this).parents('.click-sequence');

            //  window.clockDiv = window.;

           if ($(`clock${$(this).parent().attr('id')}`).length > 0) {
               window.clockDiv = $(`clock${$(this).parent().attr('id')}`);
             } else {
               window.clockDiv = $(`<div class="clock" id="clock${$(this).parent().attr('id')}"> </div>`); // .insertBefore(this)
               window.clockDiv.insertBefore(this);
             }

            // clockDiv = $(this).parent().find('.clock');

           window.clock = window.clockDiv.FlipClock($(this).data('timelimit'), {
               clockFace: 'MinuteCounter',
               countdown: true,
               callbacks: {
                   stop() {
                       $('.click-sequence .sequence-activity-wrapper').hide();       // Hide all the activities by default
                        // $('.final-feedback').click();
                       window.clockDiv.hide();
                       window.clockDiv.remove();

                       const rangeContainer = parentDiv.parents('.ChildActivities').parent().find('.FeedbackRangeContainer');
                       console.log(rangeContainer);

                       if (DEBUGGING) console.log(clockStopReason);
                       if (clockStopReason == 'too-many-incorrect') {
                           if (DEBUGGING) console.log('Too many incorrect responses');
                           rangeContainer.find('.FeedbackRangeContainer [data-trigger="Number of tries"]').show();
                           showFeedback();
                         } else if (clockStopReason == 'last-question') {
                           if (DEBUGGING) console.log('Reached the end with no issues');
                           rangeContainer.find('.final-feedback').click();
                            // ('.final-feedback').click();
                           showFeedback();
                         } else {
                           if (DEBUGGING) console.log('Timeout has been reached');
                           rangeContainer.find('.FeedbackRangeContainer [data-trigger="Timeout"]').show();
                         }
                     },
                 },
             });
           window.clock.start();

           $(this).parent().find('div[data-sequence="1"]').show();
           $(this).hide();
         });
     } else {
       $('.click-sequence .sequence-activity-wrapper[data-sequence="1"]').show();       // Hide all the activities by default
     }
   $('.click-sequence .next-sequence-activity').click(function () {
       parentDiv = $(this).parents('.click-sequence');

       if (DEBUGGING) console.log('Triggering the next in sequence');

       const curPos = $(this).data('sequence');
       const curDiv = $(this).parents('.sequence-activity-wrapper');
       const nextDiv = parentDiv.find(`div[data-sequence="${curPos + 1}"]`);

       if (curDiv.find('.isActivity').hasClass('ShortAnswerQuestion')) {
           const result = SASubjectiveFeedbackHandler(curDiv.find('.feedback-button'), curDiv.find('.ShortAnswerQuestion'));
           if (!result) numIncorrect++;
           if (DEBUGGING) console.log('Num incorrect:', numIncorrect, 'Threshold:', parentDiv.data('num-incorrect'));

           if (numIncorrect >= parentDiv.data('num-incorrect') && (parentDiv.data('num-incorrect') > 0)) {
               clockStopReason = 'too-many-incorrect';
               window.clock.stop();
             } else if ($(this).hasClass('last')) {
               clockStopReason = 'last-question';
               window.clock.stop();           // Trigger a wrap up here instead so there is less duplication
             } else {
               nextDiv.show();
               curDiv.hide();
             }
         }
     });
 });



// WEBPACK FOOTER //
// Glasshouse/Core/js/clickThroughSequence.js